import { gql } from 'graphql-tag';

export const getHirerAccountQuery = gql`
  query GetHirerAccount($advertiserId: Int!) {
    hirerAccount(advertiserId: $advertiserId) {
      priceVisibility
      pricingModel
    }
  }
`;
